import { keepPreviousData, useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { instance } from "@/lib/axios/instance";
import { useAuth } from "@/lib/hooks/useAuth";
import { ClientFilter } from "@/types/response/ClientType";
import { GetCountResponse } from "@/types/response/GetCountResponse";
import { GetVacancyCountResponse } from "@/types/response/GetVacancyCountResponse ";

type ClientCountProps = {
  filter: ClientFilter;
  search: string | undefined;
}

type ClientCountContextType = {
  countByFilter: GetVacancyCountResponse | undefined
  countByFilterFetching: boolean
  countByFilterLoading: boolean
}

export const useClientCount = ({ filter, search }: ClientCountProps): ClientCountContextType => {
  const { tenantId } = useAuth();

  const { data: countByFilter, isLoading: countByFilterLoading, isFetching: countByFilterFetching }: UseQueryResult<GetCountResponse, AxiosError> = useQuery({
    queryKey: ['client', 'count', filter, search, tenantId],
    queryFn: () => instance.post('/api/v2/Clients/Count', {
      ...filter,
      search,
      tenantId
    }).then((res) => res.data),
    refetchOnReconnect: false,
    staleTime: 10 * 60 * 1000,
    placeholderData: keepPreviousData,
  });

  const value = {
    countByFilter,
    countByFilterFetching,
    countByFilterLoading,
  }

  return value;
};
